import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { FilterList } from '@mui/icons-material';
export var Icons;
(function (Icons) {
    Icons.Login = LoginIcon;
    Icons.Menu = MenuIcon;
    Icons.Close = CloseIcon;
    Icons.ArrowDown = KeyboardArrowDownOutlinedIcon;
    Icons.ArrowUp = KeyboardArrowUpOutlinedIcon;
    Icons.Recent = AccessTimeIcon;
    Icons.Media = FolderCopyIcon;
    Icons.Book = ImportContactsIcon;
    Icons.Contact = ContactPhoneIcon;
    Icons.Search = SearchIcon;
    Icons.Back = ArrowBackIcon;
    Icons.Account = AccountCircleIcon;
    Icons.Filter = FilterList;
})(Icons || (Icons = {}));
